import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Renderer2
} from '@angular/core';
import { asapScheduler } from 'rxjs';

/* USAGE:
  <div
    matTooltip="Very long text here"
    matTooltipClass="classes for your tooltip"
    [matTooltipDisabled]="!(myEllipsifiedEl?.classList?.contains?.('ellipsified'))"
    matTooltipPosition="position of tooltip"
    >
    <span appEllipsify #myEllipsifiedEl> Very long text here </span>
  </div>

  Note: ellipsify: this class will be added automatically to the element to which appEllipsify is applied,
  You can use this class to set any specific style prop.
*/

@Directive({
    selector: '[appEllipsify]',
    standalone: false
})
export class EllipsifyDirective implements AfterViewInit {
  domElement: any;

  constructor(private renderer: Renderer2, private elementRef: ElementRef) {

    this.domElement = this.elementRef.nativeElement; // to get DOM element and store it in global variable
    // setting compulsory required styles to the DOM element
    const styles = [
      { key: 'text-overflow', value: 'ellipsis' },
      { key: 'overflow', value: 'hidden' },
      { key: 'white-space', value: 'nowrap' },
      { key: 'display', value: 'block' },
    ];

    styles.forEach((style) => {
      this.renderer.setStyle(this.domElement, style?.key, style.value);
    });

    // this.renderer.addClass(this.domElement, 'ellipsify');
  }

  @HostListener('mouseenter')
  @HostListener('mouseover')
  onMouseEnter(): void {
    asapScheduler.schedule(() => {
      // to add or remove ellipsified class on the element when it is changing width.
      if (this.domElement.offsetWidth < this.domElement.scrollWidth) {
        this.renderer.addClass(this.domElement, 'ellipsified');
      }
      else {
        this.renderer.removeClass(this.domElement, 'ellipsified');
      }
    });
  }

  @HostListener('mouseleave')
  @HostListener('mouseout')
  onMouseLeave(): void {
    this.renderer.removeClass(this.domElement, 'ellipsified');
  }

  // to check and add title attribute on the element at the time when application renders first time.
  ngAfterViewInit(): void {
    // to see effect try removing below two lines and check if the title is added at the first time rendering.
    this.renderer.setProperty(this.domElement, 'scrollTop', 1);
    this.onMouseEnter();
  }
}
